export const INSURANCE_PRICE: number = 2.8;

export const INSURANCE_INFO = [
  'Cobertura médica de hasta $40,000.',
  'Cobertura cancelación e interrupción de viajes hasta $250.',
  'Pérdida de pasaporte $100.',
  'Demora de equipaje hasta $100.',
  'Pérdida de equipaje complementaria hasta $800.',
] as const;
